// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a25839e1","578":"35534de6","622":"7df2f447","977":"cc689f9d"}[chunkId] + ".chunk.js";
};